import { Link } from "react-router-dom";
import type { Movie } from "@/lib/types";
import { getCastOf } from "@/lib/media";

export default function CastGrid({ movie }: { movie: Movie }) {
  const cast = getCastOf(movie);

  return (
    <section className="mt-8" aria-label="演员名单">
      <div className="mb-4 flex items-end justify-between">
        <div>
          <h2 className="text-lg font-bold text-foreground-950 md:text-xl">演员名单</h2>
          <p className="mt-1 text-xs text-foreground-500">点击演员卡片可查看完整资料与参演作品</p>
        </div>
        <span className="font-label text-xs font-medium text-foreground-400">{cast.length} 位主要演员</span>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        {cast.map((member) => {
          const name = member.actor?.name ?? "神秘演员";
          return (
            <Link
              key={`${member.actorId}-${member.role}`}
              to={`/actor/${member.actorId}`}
              className="group flex cursor-pointer items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 hover:bg-primary-50/40"
            >
              <div className="h-12 w-12 shrink-0 overflow-hidden rounded-full bg-secondary-100">
                {member.actor && (
                  <img
                    src={member.actor.avatar}
                    alt={`${name} 头像`}
                    title={`${name} 演员资料`}
                    className="h-full w-full object-cover object-top"
                  />
                )}
              </div>
              <div className="min-w-0 flex-1">
                <p className="line-clamp-1 text-sm font-semibold text-foreground-950 group-hover:text-primary-700">
                  {name}
                </p>
                <p className="mt-0.5 line-clamp-1 text-xs text-foreground-500">饰 {member.role}</p>
              </div>
              <i className="ri-arrow-right-s-line shrink-0 text-base text-foreground-300 group-hover:text-primary-500" />
            </Link>
          );
        })}
      </div>
    </section>
  );
}